import { render, staticRenderFns } from "./plateNo.vue?vue&type=template&id=b52178d2&scoped=true"
import script from "./plateNo.vue?vue&type=script&lang=js"
export * from "./plateNo.vue?vue&type=script&lang=js"
import style0 from "./plateNo.vue?vue&type=style&index=0&id=b52178d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52178d2",
  null
  
)

export default component.exports